<app-docu-upsell-dialog>
  <ng-template pTemplate="title">
    Tyvärr kräver denna funktion en prenumeration.
  </ng-template>
</app-docu-upsell-dialog>
